export default __webpack_public_path__ + "static/media/hammer-mill-icon.9c58d46b.svg";